<div class="title-container">
  <h1 *ngIf="data.type === 'promo'" class="heading" mat-dialog-title>{{ 'orderPanel.globalMessagesModal.promoHeading' | translate }}</h1>
  <h1 *ngIf="data.type === 'warning' || data.type === 'info'">{{ 'orderPanel.globalMessagesModal.attentionHeading' | translate }}</h1>

  <div class="action-container" mat-dialog-actions>
    <mat-icon (click)="hideModal()">expand_more</mat-icon>
    <mat-icon (click)="closeModal()">close</mat-icon>
  </div>
</div>

<div class="text-modal">
  <p *ngIf="data.type === 'promo'">{{ 'orderPanel.globalMessagesModal.streamer' | translate }} <span class="streamer-name">{{streamerName | uppercase}}</span> {{ 'orderPanel.globalMessagesModal.promoMessage' | translate }}</p>
  <p>{{data.type === 'warning' ? getMessageForModal('warning') : getMessageForModal('info')}}</p>
</div>
<div class="promo-container" *ngIf="data.type === 'promo'">
  <p class="present-promo" #promoText>{{promoCode}}</p>
  <mat-icon (click)="copyText()" [cdkCopyToClipboard]="promoText.textContent">content_copy</mat-icon>
</div>
